import React from "react";
import { Tabs } from "@shared/ui/tabs";
import WorkOrderList from "./WorkOrderList";
import CreateServiceOrderDialog from "./CreateServiceOrderDialog";
import { Plus } from "lucide-react";
import { Button } from "@shared/ui/button";
import { useNavigate } from "react-router-dom";

export const WorkOrders: React.FC = () => {
  const navigate = useNavigate();
    const tabComponents = {
    all: {
      label: "All Orders",
      shortLabel: "All",
      component: <WorkOrderList status="ALL" />,
    },
    new: {
      label: "Created",
      shortLabel: "New",
      component: <WorkOrderList status="CREATED" />,
    },
    assigned: {
      label: "Assigned",
      shortLabel: "Assigned",
      component: <WorkOrderList status="ASSIGNED" />,
    },
    inProgress: {
      label: "In Progress",
      shortLabel: "Progress",
      component: <WorkOrderList status="IN_PROGRESS" />,
    },
    completed: {
      label: "Completed",
      shortLabel: "Done",
      component: <WorkOrderList status="COMPLETED" />,
    },
    approved: {
      label: "Approved",
      shortLabel: "Approved",
      component: <WorkOrderList status="APPROVED" />,
    },
  };

  const urlMapping = {
    all: "all",
    new: "new",
    assigned: "assigned",
    inProgress: "Progress",
    completed: "Done",
    approved: "Approved",
  };

    const handleCreateClick = () => {
    // 🧹 Clear localStorage before navigation
    localStorage.removeItem("create-service-order-progress");

    // 🚀 Navigate to new page
    navigate("/mx/device-management/service-order-create");
  };

  
  return (
    <div className="w-full p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <div>
          <h2 className="page-title">Service Orders</h2>
          <p className="page-subtitle">
            Create, assign, and track service orders for consumer-related
            operations.
          </p>
        </div>
         <Button onClick={handleCreateClick}>
          <Plus className="mr-2 h-4 w-4" />
          Create Service Order
        </Button>
      </div>

      <Tabs
        defaultValue="all"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid grid-cols-6"
        className="space-y-4"
        level={0}
      />
    </div>
  );
};
